import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

/** Required for `formatDate(..., 'pt-BR')` (e.g. user detail timestamps). */
registerLocaleData(localePt, 'pt-BR');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
